import { useDispatch } from 'react-redux';

import { setUser } from '../actions/userActions';
import { setNetworks } from '../actions/networksActions';
import { trackEvent } from '../helpers/analytics';
import { useSignUpMutation } from '../services/user';
import { setupUserSession } from '../services/auth';

export const useSignUp = () => {
  const [userSignUp, { isLoading }] = useSignUpMutation();
  const dispatch = useDispatch();

  const signUp = (values) =>
    userSignUp(values)
      .unwrap()
      .then((response) => setupUserSession(response))
      .then((user) => {
        dispatch(setUser(user));
        dispatch(setNetworks(user));

        return user;
      })
      .catch((error) => {
        if (error?.status === 401) {
          trackEvent('log_in_invalid');
        }

        throw error;
      });

  return { signUp, isLoading };
};
